"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _index = _interopRequireDefault(require("./AssembleGridHeader/index"));

var _AssembleRule = _interopRequireDefault(require("./AssembleRule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AssembleGridContainer = function AssembleGridContainer(_ref) {
  var headerTitle = _ref.headerTitle,
      columnRangeType = _ref.columnRangeType,
      columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      startDatetime = _ref.startDatetime,
      onDivisionSummary = _ref.onDivisionSummary,
      className = _ref.className,
      extended = _ref.extended,
      scrollable = _ref.scrollable;
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    headerTitle: headerTitle
  }), /*#__PURE__*/_react["default"].createElement(_AssembleRule["default"], {
    columnRangeType: columnRangeType,
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    onDivisionSummary: onDivisionSummary,
    extended: extended,
    scrollable: scrollable
  }));
};

AssembleGridContainer.propTypes = {
  headerTitle: _propTypes["default"].any,
  columnRangeType: _propTypes["default"].string,
  columnSections: _propTypes["default"].number,
  columnQuantity: _propTypes["default"].number,
  startDatetime: _propTypes["default"].instanceOf(Date),
  onDivisionSummary: _propTypes["default"].func,
  className: _propTypes["default"].string,
  extended: _propTypes["default"].bool
};
AssembleGridContainer.defaultProps = {
  headerTitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  columnRangeType: 'DAY',
  columnSections: 4,
  columnQuantity: 8,
  startDatetime: new Date(),
  onDivisionSummary: function onDivisionSummary() {},
  className: '',
  extended: false
};
var _default = AssembleGridContainer;
exports["default"] = _default;